const AppRoutes = {
  home: '/',

  login: '/login',
  register: '/register',
  resetPassword: '/reset-password',

  survey: '/survey',
  surveyCreate: '/survey/create',
  surveyEdit: '/survey/edit/:id',
  surveyEditFn: (id) => `/survey/edit/${id}`,
  surveyView: '/survey/view/:id',
  surveyViewFn: (id) => `/survey/view/${id}`,
  surveyTemplate: '/survey/template/:id',
  surveyTemplateFn: (id) => `/survey/template/${id}`,

  report: '/report',
  reportView: '/report/view/:id',
  reportViewFn: (id) => `/report/view/${id}`,
  reportSDQ: '/report/sdq/:id',
  reportSDQFn: (id) => `/report/sdq/${id}`,

  users: '/users',

  evaluationAnalysis: '/evaluation-analysis',
  sampleVideo: '/sample-video',
  chat: '/chat',
};

export default AppRoutes;
